import AppProvider from 'providers/AppProvider';
import React from 'react';
import ReactDOM from 'react-dom/client';
import BreakpointsProvider from 'providers/BreakpointsProvider';
import { RouterProvider } from 'react-router-dom';
import { router } from 'Routes';
import { store } from './app/store';
import { Provider } from 'react-redux';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppProvider>
        <BreakpointsProvider>
          <RouterProvider router={router} />
        </BreakpointsProvider>
      </AppProvider>
    </Provider>
  </React.StrictMode>
);

serviceWorkerRegistration.register({
  onUpdate: registration => {
    registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
  }
});
